import React, { useEffect, useState } from "react";
import { CLIENT_LOGOS as FALLBACK_LOGOS } from "../data/mock";
import { api } from "../lib/api";

const LogoCard = ({ logo }) => {
  if (logo.src) {
    const isDark = logo.bg === "dark";
    return (
      <div
        className={`shrink-0 w-[180px] md:w-[200px] h-[90px] md:h-[100px] rounded-2xl border shadow-[0_4px_18px_-6px_rgba(0,0,0,0.08)] hover:shadow-[0_10px_30px_-10px_rgba(0,0,0,0.18)] hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center px-5 group ${
          isDark
            ? "bg-neutral-900 border-neutral-800"
            : "bg-white border-black/5"
        }`}
      >
        <img
          src={logo.src}
          alt={logo.name}
          className="max-h-[68px] max-w-full object-contain transition-transform duration-300 group-hover:scale-[1.05]"
          loading="lazy"
          decoding="async"
        />
      </div>
    );
  }
  // Text-based badge for additional brands
  return (
    <div className="shrink-0 h-[90px] md:h-[100px] flex items-center justify-center px-2">
      <span
        className={`text-2xl md:text-3xl text-neutral-400 hover:text-neutral-900 transition-colors duration-300 whitespace-nowrap ${
          logo.style || ""
        }`}
      >
        {logo.name}
      </span>
    </div>
  );
};

const LogoMarquee = () => {
  const [logos, setLogos] = useState(FALLBACK_LOGOS);

  useEffect(() => {
    api
      .get("/site-config")
      .then((r) => {
        const list = r.data?.client_logos || [];
        if (list.length > 0) setLogos(list);
      })
      .catch(() => {});
  }, []);

  const loop = [...logos, ...logos];

  return (
    <section className="py-16 md:py-24 border-y border-black/5 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <p className="text-center text-xs md:text-sm uppercase tracking-[0.3em] text-neutral-500 font-semibold mb-12">
          Bereits gearbeitet für / mit:
        </p>
      </div>

      <div className="relative overflow-hidden">
        <div className="absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        <div className="flex items-center gap-6 md:gap-8 marquee-track">
          {loop.map((logo, idx) => (
            <LogoCard key={`${logo.name}-${idx}`} logo={logo} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
